import pcbanglogo from './pcbanglogo.png'
import { lorem, dynamicResourceLinks } from './util';

const ContactUs = () => {
	let pcbemail = "pcbang.contact@gmail.com"
	let pcbfb = "https://web.facebook.com/PCBANG.MA"
	let pcbtwr = "https://twitter.com/PCBANG_G"
	let pcbig = "https://www.instagram.com/pcbang_g/"
	return (
		<div className="contactus pagebody">
			<div className="mainbody">
				<div className="navpad"></div>
				<div className="navpad"></div>
				<div className="navpad"></div>
				<div className="navpad"></div>
				<div className="navpad"></div>
				<div className="navpad"></div>
				<div className="hero">
					<img src={pcbanglogo} alt="" className="logo" />
					<div className="container headings">
						<h1 className="contact">CONTACT</h1>
						<h1 className="us">US</h1>
					</div>
				</div>
				<div className="navpad"></div>
				<div className="navpad"></div>
				<div className="navpad"></div>
				<div className="navpad"></div>
				<div className="navpad"></div>

				<form action={"mailto:" + pcbemail} method="GET">
					<div className="namesubjectdesc">
						<div className="desc">
							{lorem(30)}
						</div>
						<div className="namesubject">
							<input name="name" type="text" className='name textinput' placeholder='YOUR NAME' />
							<input name="subject" type="text" className='subject textinput' placeholder='THE SUBJECT' />
						</div>
					</div>
					<textarea name="body" className='body textinput' placeholder='YOUR MESSAGE'></textarea>
					<input type="submit" value="SEND" className='submitbutton' />
				</form>
				<div className="navpad"></div>
				<div className="navpad"></div>
				<div className="navpad"></div>
				<div className="navpad"></div>
				<div className="navpad"></div>
				<div className="socialmediaicons">
					<img src={dynamicResourceLinks("ff0099", 100).facebookIcon} alt="facebook" className="facebook" onClick={() => { window.location = pcbfb }} />
					<img src={dynamicResourceLinks("ff0099", 100).twitterIcon} alt="twitter" className="twitter" onClick={() => { window.location = pcbtwr }} />
					<img src={dynamicResourceLinks("ff0099", 100).instagramIcon} alt="instagram" className="instagram" onClick={() => { window.location = pcbig }} />
				</div>
			</div>
		</div>
	);
}

export default ContactUs;